import i18n from 'i18next';
import * as Yup from 'yup';
import { Permissao } from '../../../@types/exports';

const validarErroForm = async (data: Permissao) => {
  const schema = Yup.object().shape({
    name: Yup
      .string()
      .matches(/^(\S+$)/g, i18n.t('permissoes.validacao.espacoBranco'))
      .required(i18n.t('permissoes.validacao.nomeClientCredentias')),
    description: Yup
      .string()
      .required(i18n.t('permissoes.validacao.descricao')),
  });

  await schema.validate(data, {
    abortEarly: false,
  });
};

export default validarErroForm;
